export const ThemeColor = {
    mainbgcolor: "#424141",
    kakaobtncolor: "#fef01b",
    mainTxtcolor : "#fff",
};
